import { ServiceMaker, methods, services } from "../services";

export const createAccessrule = (payload) =>
  ServiceMaker(
    `/access-rules`,
    methods.POST,
    services.subscriptionpayments,
    payload
  );

export const fetchAccessRuleList = () =>
  ServiceMaker(`/access-rules`, methods.GET, services.subscriptionpayments);

export const editAccessrule = (payload) =>
  ServiceMaker(
    `/access-rules/${payload.id}`,
    methods.POST,
    services.subscriptionpayments,
    payload.data
  );
